document.querySelectorAll('[data-ab-test-id]').forEach(function (section) {
  // Variants may ship as an inert <template> so crawlers only see one. The
  // active variant's markup lives in its mount point; the inactive one's lives
  // in its template, so only one variant is ever in the rendered DOM. Nodes
  // are moved rather than cloned: click listeners survive a stash/restore and
  // inline scripts only run on first insertion. Sections that ship without
  // templates (older markup) fall back to toggling display.
  function getTemplate(v, create) {
    var tpl = section.querySelector('template[data-ab-variant-template="' + v + '"]');
    if (!tpl && create) {
      tpl = document.createElement('template');
      tpl.setAttribute('data-ab-variant-template', v);
      section.appendChild(tpl);
    }
    return tpl;
  }

  function restoreVariant(v) {
    var el = section.querySelector('[data-ab-variant="' + v + '"]');
    var tpl = getTemplate(v, false);
    if (el && tpl) el.appendChild(tpl.content);
    return el;
  }

  function stashVariant(v) {
    var el = section.querySelector('[data-ab-variant="' + v + '"]');
    if (!el) return;
    var tpl = getTemplate(v, true);
    while (el.firstChild) tpl.content.appendChild(el.firstChild);
    el.hidden = true;
  }

  var usesTemplates = !!section.querySelector('template[data-ab-variant-template]');

  // In the Shopify theme customizer or any admin iframe — show both variants, no tracking
  var inAdmin =
    (typeof Shopify !== 'undefined' && Shopify.designMode) ||
    (window.self !== window.top &&
      (Array.from(window.location.ancestorOrigins || []).some(function (o) {
        return o.includes('admin.shopify.com');
      }) ||
        document.referrer.includes('admin.shopify.com')));

  if (inAdmin) {
    section.querySelectorAll('[data-ab-variant]').forEach(function (el) {
      restoreVariant(el.dataset.abVariant);
      el.style.display = '';
      el.removeAttribute('hidden');
    });
    return;
  }

  var testId = section.dataset.abTestId;
  var testName = section.dataset.abTestName || null;
  var endpoint = 'https://habitat-app-ab.vercel.app';
  var threshold = parseInt(section.dataset.abThreshold, 10) || 5;

  if (!testId) return;

  // Determine variant: declared winner > previous assignment > random
  var winnerKey = 'ab_winner_' + testId;
  var variantKey = 'ab_variant_' + testId;
  var isFirstVisit = !localStorage.getItem(winnerKey) && !localStorage.getItem(variantKey);
  var variant = localStorage.getItem(winnerKey) || localStorage.getItem(variantKey);

  if (!variant) {
    variant = Math.random() < 0.5 ? 'a' : 'b';
    localStorage.setItem(variantKey, variant);
  }

  // Show correct variant
  function showVariant(v) {
    if (usesTemplates) {
      section.querySelectorAll('[data-ab-variant]').forEach(function (el) {
        if (el.dataset.abVariant !== v) stashVariant(el.dataset.abVariant);
      });
    }
    var activeEl = restoreVariant(v);
    section.querySelectorAll('[data-ab-variant]').forEach(function (el) {
      el.style.display = el.dataset.abVariant === v ? '' : 'none';
    });
    if (activeEl) activeEl.removeAttribute('hidden');
    return activeEl;
  }
  // Activate before metadata extraction and click binding below
  var activeEl = showVariant(variant);

  // Extract all copy from variant — works with block-composed content (_text-component, _buttons, etc.)
  function extractMetadata(el) {
    if (!el) return null;
    var headings = Array.from(el.querySelectorAll('h1, h2, h3, h4'))
      .map(function (h) {
        return h.textContent.trim();
      })
      .filter(Boolean);
    // .eyebrow = _eyebrow block (short label above heading)
    var eyebrows = Array.from(el.querySelectorAll('.eyebrow'))
      .map(function (e) {
        return e.textContent.trim();
      })
      .filter(Boolean);
    // p = _richtext paragraphs; .list-item-text = _unordered-list-item block
    var paragraphs = Array.from(el.querySelectorAll('p, .list-item-text'))
      .map(function (p) {
        return p.textContent.trim();
      })
      .filter(Boolean);
    var buttons = Array.from(el.querySelectorAll('a[href], button'))
      .map(function (b) {
        return b.textContent.trim();
      })
      .filter(Boolean);
    // .badge = _badge block (promo labels: "New Formula", "Free Shipping", etc.)
    var badges = Array.from(el.querySelectorAll('.badge'))
      .map(function (b) {
        return b.textContent.trim();
      })
      .filter(Boolean);
    var img = el.querySelector('img');
    return {
      headings: headings,
      eyebrows: eyebrows,
      paragraphs: paragraphs,
      buttons: buttons,
      badges: badges,
      imageUrl: img ? img.currentSrc || img.src || null : null,
      // Flat fields stored in DB
      heading: headings[0] || null,
      subheading: paragraphs[0] || null,
      buttonText: buttons[0] || null,
    };
  }

  // Track event — keepalive:true survives page navigation, credentials:omit avoids CORS preflight issues
  function trackEvent(event, meta) {
    var shopDomain = typeof Shopify !== 'undefined' && Shopify.shop ? Shopify.shop : null;
    var payload = JSON.stringify({
      testId: testId,
      name: testName,
      variant: variant,
      event: event,
      threshold: threshold,
      metadata: meta || null,
      shopDomain: shopDomain,
    });
    fetch(endpoint + '/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
      credentials: 'omit',
    }).catch(function () {});
  }

  // Fire impression only on first visit — localStorage prevents duplicates on refresh
  if (isFirstVisit) {
    trackEvent('impression', extractMetadata(activeEl));
  }

  // Track any link or button click within the active variant
  function bindClicks(el) {
    if (!el || el.abClicksBound) return;
    el.abClicksBound = true;
    el.querySelectorAll('a[href], button').forEach(function (target) {
      target.addEventListener('click', function () {
        trackEvent('click');
      });
    });
  }
  bindClicks(activeEl);

  // Check for a declared winner and switch if needed
  fetch(endpoint + '/api/winner?testId=' + encodeURIComponent(testId), { credentials: 'omit' })
    .then(function (r) {
      return r.ok ? r.json() : null;
    })
    .then(function (data) {
      if (!data || !data.winner) return;
      localStorage.setItem(winnerKey, data.winner);
      if (data.winner !== variant) {
        // Clicks on the newly shown variant are attributed to it
        variant = data.winner;
        activeEl = showVariant(data.winner);
        bindClicks(activeEl);
      }
    })
    .catch(function () {});
});
